export default __webpack_public_path__ + "img/742ab84c72ad1498ceea95acd77f246f.svg";